var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1237.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3 {\n        opacity: .5;\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient);\n        isolation: isolate;\n        opacity: .1;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 339.3,
    y1: 1968.17,
    x2: 557.36,
    y2: 1459.36,
    gradientTransform: "translate(0 2599.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1e3f6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 606.72,
    cy: 2456.09,
    fx: 267.84,
    fy: 2473.69,
    r: 1547.56,
    gradientTransform: "translate(0 2298.14) scale(1 -.73)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1e3f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 962.75,
    y1: 1559.68,
    x2: 958.74,
    y2: 2373.16,
    gradientTransform: "translate(0 2599.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1e3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 882.15,
    y1: 2103.84,
    x2: 970.86,
    y2: 1514.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1434.16,
    y1: 2068.62,
    x2: 1498.49,
    y2: 1657.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 956.21,
    y1: 2043.05,
    x2: 963.08,
    y2: 1308.07,
    gradientTransform: "translate(0 2599.57) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e1edf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#d1e3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m832.7,747.99C501.9,669.69.9,662.19.9,662.19v214.3l831.8-128.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.9,283.79h1919.1v863.5H.9V283.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.9,0h1919.1v1147.29H.9V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1821.1,622.99c-312.5,19.9-593.9-106.4-963.4-117.1S132.9,614.29,0,614.29v131.8l1768.4-25.8,52.7-97.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m973.8,688.47c307.6,3.2,741.1-152.2,946.2-152.2v264.2l-946.2-112h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1920,783.09v454.2H.9v-489.9c225.9,34.9,443-34.7,831.3-61.7,271.6-18.9,512.1,29.4,760.2,64.9,1.1.2,2.1.3,3.2.5,36.3,5.2,72.8,10.1,109.5,14.5,7,.8,13.9,1.6,20.9,2.4,6,.7,12.1,1.4,18.1,2,4.7.5,9.5,1,14.2,1.5,53.1,5.4,106.9,9.6,161.7,11.6h0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.a4ad10f0fb4718436425cf393d8b5bc7.svg";
export { ForwardRef as ReactComponent };